import styled from "styled-components";
import { Select } from "@songtradr/component-library";

// TEXT

// STYLES
export const SelectWidth = styled(Select)`
  display: flex;
  width: max-content;
  gap: 1rem;
  cursor: pointer;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
